module.exports = __webpack_public_path__ + "img/C06TechSpearmanChampion_ua.3d17684a.webp";